export { Carousel as default } from "./carousel.component";
